import { API } from '@Providers';
import type { DonationAtCart } from '../types';

export default async function (payload: DonationAtCart) {
  const endpoint = '/api/shelter/cart/donation';

  return API({ endpoint, method: 'put', payload });
}
